export const RANKING_TOOLTIPS_SHOW = "RANKING_TOOLTIPS_SHOW";
export const RANKING_TOOLTIPS_HIDE = "RANKING_TOOLTIPS_HIDE";

export const tooltipsShowAction = () =>({
    type: RANKING_TOOLTIPS_SHOW
});

export const tooltipsHideAction = () => ({
    type: RANKING_TOOLTIPS_HIDE
});
